import React from "react";

import {
  ContainerTitle,
  ContainerTitleText,
  TablaBody,
  TablaHeaderTextoItems,
  TablaHeaderTextoValues,
  Tabla,
  LinkCancelar,
  ContainerBody,
  Select,
  ButtonPagar,
  ItemContainer,
  ButtonInsideContainer,
  InputButton,
  ButtonInside,
} from "./styles";

export const AutorizaOrden = ({
  orden,
  labs,
  onCloseModal,
  refOrden,
  onEnviar,
  onChangeOrden,
  onChangeItem,
  onRemove,
}) => {
  return (
    <form ref={refOrden}>
      <ContainerTitle>
        <ContainerTitleText>Autoriza Orden</ContainerTitleText>
      </ContainerTitle>
      <ContainerBody>
        <Tabla>
          <TablaBody>
            <tr>
              <TablaHeaderTextoItems>Laboratorio</TablaHeaderTextoItems>
              <TablaHeaderTextoValues>
                <select id="labId" name="labId" value={orden.labId} disabled>
                  {labs.map((lab) => (
                    <option value={lab.id}>{lab.razonSocial}</option>
                  ))}
                </select>
              </TablaHeaderTextoValues>
            </tr>
            <tr>
              <TablaHeaderTextoItems>
                <strong>Fec. Envío: </strong>
              </TablaHeaderTextoItems>
              <TablaHeaderTextoValues data-label="envio">
                <input
                  type="date"
                  value={orden.fecEnv}
                  name="fecEnv"
                  required
                  disabled
                ></input>
              </TablaHeaderTextoValues>
            </tr>
            <tr>
              <TablaHeaderTextoItems>
                <strong>Fecha Prueba: </strong>
              </TablaHeaderTextoItems>
              <TablaHeaderTextoValues data-label="recep">
                <input
                  type="date"
                  value={orden.fecRec}
                  name="fecRec"
                  onChange={onChangeOrden}
                  required
                  disabled
                ></input>
              </TablaHeaderTextoValues>
            </tr>
          </TablaBody>
        </Tabla>

        {orden.items.map((item, index) => (
          <ItemContainer>
            <div>{` ${item.nombre} dientes:[${item.dientes}] S/ ${item.precio}`}</div>
            <div>
              <div>
                <input
                  type="text"
                  name="precioFinal"
                  value={item.precioFinal}
                  onChange={(e) => onChangeItem(e, index)}
                  disabled
                />
              </div>
              <div>
                <textarea
                  name="nota"
                  rows="3"
                  cols="50"
                  placeholder="Descripcion de la Nota"
                  value={item.nota}
                  disabled
                ></textarea>
              </div>
            </div>
            <div>
              <label>terminado</label>
              <input
                name="terminado"
                type="checkbox"
                checked={item.terminado}
                value={item.terminado}
                disabled
              ></input>
            </div>
            <div>
              <button onClick={() => onRemove(item.id)}>Quitar</button>
            </div>
          </ItemContainer>
        ))}
      </ContainerBody>
      <div>
        <LinkCancelar onClick={onCloseModal}>Cancelar</LinkCancelar>
        <ButtonPagar onClick={onEnviar}>Autorizar</ButtonPagar>
      </div>
    </form>
  );
};
